const SimpleTemplate = ({ candidateData }) => {
    if (!candidateData) return null

    const {
        name,
        email,
        phone,
        basic_details,
        employment,
        education,
        projects,
        certifications,
        it_skills,
        candidate_languages,
    } = candidateData

    return (
        <div className="resume-simple w-[210mm] min-h-[297mm] max-w-[210mm] mx-auto p-[20mm_15mm] bg-white text-gray-800 box-border relative font-sans overflow-hidden">
            {/* Header */}
            <div className="text-center mb-6">
                <h1 className="text-3xl font-bold">{name}</h1>
                <p className="mt-2 text-lg">{employment?.[0]?.job_title?.title || "Professional"}</p>
                <div className="flex justify-center space-x-4 mt-3 flex-wrap">
                    <span>{email}</span>
                    <span>|</span>
                    <span>{phone}</span>
                    <span>|</span>
                    <span>
                        {basic_details?.city?.name}, {basic_details?.state?.name}
                    </span>
                </div>
            </div>

            <hr className="border-gray-300 my-4" />

            {/* Summary */}
            {basic_details?.profile_summery && (
                <div className="mb-6">
                    <h2 className="text-base border-b border-gray-300 pb-2 mb-3">SUMMARY</h2>
                    <p className="text-sm leading-relaxed">{basic_details.profile_summery}</p>
                </div>
            )}

            {/* Experience */}
            {employment && employment.length > 0 && (
                <div className="mb-6">
                    <h2 className="text-base border-b border-gray-300 pb-2 mb-3">EXPERIENCE</h2>
                    <div className="space-y-4">
                        {employment.map((job, index) => (
                            <div key={index}>
                                <div className="flex justify-between mb-1 flex-wrap">
                                    <h3 className="text-sm font-bold">{job.job_title?.title}</h3>
                                    <span className="text-sm">
                                        {job.start_month}/{job.start_year} -{" "}
                                        {job.end_month ? `${job.end_month}/${job.end_year}` : "Present"}
                                    </span>
                                </div>
                                <p className="font-medium mb-2">{job.current_company}</p>
                                <p className="text-sm leading-relaxed">{job.job_profile}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Education */}
            {education && education.length > 0 && (
                <div className="mb-6">
                    <h2 className="text-base border-b border-gray-300 pb-2 mb-3">EDUCATION</h2>
                    <div className="space-y-4">
                        {education.map((edu, index) => (
                            <div key={index}>
                                <div className="flex justify-between mb-1 flex-wrap">
                                    <h3 className="text-sm font-bold">{edu.education_course?.title}</h3>
                                    <span className="text-sm">
                                        {edu.course_duration_start_year} - {edu.course_duration_end_year}
                                    </span>
                                </div>
                                <p className="font-medium mb-2">{edu.insitute_university}</p>
                                <div className="grid grid-cols-2 gap-4 text-sm">
                                    {edu.education_course_specialty && (
                                        <p>
                                            <span className="font-medium">Specialization:</span> {edu.education_course_specialty.title}
                                        </p>
                                    )}
                                    <p>
                                        <span className="font-medium">{edu.grading_system}:</span> {edu.marks}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Skills */}
            {it_skills && it_skills.length > 0 && (
                <div className="mb-6">
                    <h2 className="text-base border-b border-gray-300 pb-2 mb-3">TECHNICAL SKILLS</h2>
                    <div className="grid grid-cols-2 gap-4">
                        {it_skills.map((skill, index) => (
                            <div key={index} className="flex justify-between">
                                <span className="text-sm font-medium">{skill.skill.title}</span>
                                <span className="text-sm text-gray-600">
                                    {skill.experience_year}y {skill.experience_month}m
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Projects */}
            {projects && projects.length > 0 && (
                <div className="mb-6">
                    <h2 className="text-base border-b border-gray-300 pb-2 mb-3">PROJECTS</h2>
                    <div className="space-y-4">
                        {projects.map((project, index) => (
                            <div key={index}>
                                <div className="flex justify-between mb-1 flex-wrap">
                                    <h3 className="text-sm font-bold">{project.project_tag}</h3>
                                    <span
                                        className={`text-xs px-2 py-1 rounded ${project.project_status === "Ongoing" ? "bg-green-100 text-green-800" : "bg-blue-100 text-blue-800"
                                            }`}
                                    >
                                        {project.project_status}
                                    </span>
                                </div>
                                <p className="text-sm mb-2 leading-relaxed">{project.project_description}</p>
                                <p className="text-xs text-gray-600">
                                    Role: {project.role} • Team Size: {project.team_size}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Certifications */}
            {certifications && certifications.length > 0 && (
                <div className="mb-6">
                    <h2 className="text-base border-b border-gray-300 pb-2 mb-3">CERTIFICATIONS</h2>
                    <div className="space-y-2">
                        {certifications.map((cert, index) => (
                            <div key={index}>
                                <p className="text-sm font-medium">{cert.certification_name}</p>
                                {cert.certification_date && <p className="text-xs text-gray-600">Issued: {cert.certification_date}</p>}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Languages */}
            {candidate_languages && candidate_languages.length > 0 && (
                <div>
                    <h2 className="text-base border-b border-gray-300 pb-2 mb-3">LANGUAGES</h2>
                    <div className="flex flex-wrap gap-2">
                        {candidate_languages.map((lang, index) => (
                            <span key={index} className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm">
                                {lang.language}
                            </span>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default SimpleTemplate
